import { render, staticRenderFns } from "./CreateOfferForm.vue?vue&type=template&id=2c2b4b83&"
import script from "./CreateOfferForm.vue?vue&type=script&lang=js&"
export * from "./CreateOfferForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateOfferForm.vue?vue&type=style&index=0&id=2c2b4b83&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports